import { ViewChild, Component, OnInit } from '@angular/core';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { MojoPmaNavbarService } from '@navbar/services/mojopma-navbar.service';
import { MfsPreviewModeDialogContainerComponent } from '@preview-mode/mfs-preview-mode/containers/mfs-preview-mode-dialog-container/mfs-preview-mode-dialog-container.component'
import { MftPreviewModeDialogContainerComponent } from '@preview-mode/mft-preview-mode/containers/mft-preview-mode-dialog-container/mft-preview-mode-dialog-container.component'
import { MciPreviewModeDialogContainerComponent } from "@preview-mode/mci-preview-mode/mci-preview-mode-dialog-container.component";

@Component({
  selector: 'mojo-product-preview',
  templateUrl: './product-preview.component.html',
})
export class ProductPreviewComponent implements OnInit {

  @ViewChild('mciPreviewer', { static: true })
  mciPreviewer: MciPreviewModeDialogContainerComponent;

  @ViewChild('mfsPreviewer', { static: true })
  mfsPreviewer: MfsPreviewModeDialogContainerComponent;

  @ViewChild('mftPreviewer', { static: true })
  mftPreviewer: MftPreviewModeDialogContainerComponent;

  showForProduct: string;

  constructor(private readonly mojoPmaNavbar: MojoPmaNavbarService) {
  }

  ngOnInit() {

    this.mojoPmaNavbar.requestPreviewMode.subscribe(product => {

      if (this.mciPreviewer.showDialog || this.mfsPreviewer.showDialog) return;

      if (product) {

        switch (product) {
          case MojoWellKnownNames.Products.Mci:
            this.mciPreviewer.doShowDialog();
            break;

          case MojoWellKnownNames.Products.MojoForSuppliers:
            this.mfsPreviewer.doShowDialog();
            break;

          case MojoWellKnownNames.Products.MojoForTenants:
            this.mftPreviewer.doShowDialog();
            break;

        }

      }

    });

  }



}
